import type { DefaultTranslation } from '@italia/i18n';

const translation: DefaultTranslation = {
  $code: 'it',
  $name: 'Italiano',
  $dir: 'ltr',

  // splide i18n — fonte: bsi docs
  carousel_prev: 'Slide precedente',
  carousel_next: 'Slide successiva',
  carousel_first: 'Vai alla prima slide',
  carousel_last: "Vai all'ultima slide",
  carousel_slideX: 'Vai alla slide %s',
  carousel_pageX: 'Vai a pagina %s',
  carousel_play: 'Attiva autoplay',
  carousel_pause: 'Pausa autoplay',
  carousel_carousel: 'carosello',
  carousel_select: 'Seleziona una slide da mostrare',
  carousel_slide: 'slide',
  carousel_slideLabel: '%s di %s',
  carousel_startautoplay: 'Attiva autoplay',
  carousel_stopautoplay: 'Spegni autoplay',
};

export default translation;
